import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=6d3ff1ab&scoped=true"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=6d3ff1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ff1ab",
  null
  
)

export default component.exports